import { createContext, ComponentType } from 'react';

/**
 * Позволяет точечно подменить реализацию картинки внутри определённой части
 * приложения (например, ленты FeedsApp), не меняя поведение
 * ResizedImageEnhanced для всех остальных мест.
 *
 * По умолчанию (null) используется штатная реализация — ничего не меняется.
 */
export const ResizedImageOverrideContext = createContext<ComponentType<any> | null>(
  null,
);
import { createContext, ComponentType } from 'react';

/**
 * Позволяет точечно подменить реализацию картинки внутри определённой части
 * приложения (например, ленты FeedsApp), не меняя поведение
 * ResizedImageEnhanced для всех остальных мест.
 *
 * По умолчанию (null) используется штатная реализация — ничего не меняется.
 */
export const ResizedImageOverrideContext = createContext<ComponentType<any> | null>(
  null,
);
